import React from 'react';
import { ToastModel } from '../Types/Toast';
import { toast } from 'react-toastify';
import Toast from '../Components/Toast/Toast';

export const triggerToast = ({
  title,
  text,
  type,
  autoClose = false,
}: ToastModel) => {
  toast(<Toast title={title} text={text} type={type} />, {
    position: 'bottom-right',
    autoClose: false
  });
};
